import { deletePushSubscription, getPushPubkey, savePushSubscription } from 'shared/api';
import { getDeviceName, urlBase64ToUint8Array } from 'shared/utils/sw';

export async function getPushSubscription() {
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function subscribeToPushNotifications() {
  const pubkeyRequest = getPushPubkey();
  const reg = await navigator.serviceWorker.ready;
  const { pubkey } = (await pubkeyRequest).data;
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(pubkey),
  });
  const saveRes = await savePushSubscription({
    device: getDeviceName(navigator.userAgent),
    ...sub.toJSON(),
  });
  return saveRes.data;
}

export async function unsubscribeFromPushNotifications() {
  const sub = await getPushSubscription();
  if (!sub) {
    return;
  }
  await sub.unsubscribe();
  await deletePushSubscription({ endpoint: sub.endpoint });
  return sub;
}
